// 全局遮罩检测：页面上只要有「弹窗 / 抽屉 / 铺满屏幕的半透明遮罩」开着，就通知订阅方。
// 目前用来在遮罩打开时藏起右下角的客服入口（Libredesk 挂件、SupportChatbot），
// 免得它盖在弹层内容上，也不用每个弹层自己记得去喊一声。
//
// 判断规则（满足任一即算「有遮罩」）：
// 1) Element UI 的遮罩和弹层外壳：.v-modal、el-dialog / el-drawer / el-message-box / 图片预览的 wrapper；
// 2) 自己写的遮罩：类名里带 overlay / mask，且是 position:fixed、几乎铺满视口、可见的；
// 3) 显式标记 data-hide-chat 的元素（可见即算），留给以上规则认不出来的特殊弹层。
// 客服挂件自己的 DOM 不参与判断。

const ELEMENT_SHELLS = ".v-modal, .el-dialog__wrapper, .el-drawer__wrapper, .el-message-box__wrapper, .el-image-viewer__wrapper";
const GENERIC_MASKS = '[class*="overlay"], [class*="Overlay"], [class*="mask"], [class*="Mask"]';
const EXPLICIT = "[data-hide-chat]";
const CHAT_ROOTS = ".wtk-chatbot-root";

let open = false;
let started = false;
let scheduled = false;
const listeners = new Set();

function isShown(el) {
  const cs = window.getComputedStyle(el);
  return cs.display !== "none" && cs.visibility !== "hidden" && parseFloat(cs.opacity) > 0.05;
}

function coversViewport(el) {
  if (window.getComputedStyle(el).position !== "fixed") return false;
  const r = el.getBoundingClientRect();
  return r.width >= window.innerWidth * 0.9 && r.height >= window.innerHeight * 0.9;
}

function detect() {
  const candidates = document.querySelectorAll(`${ELEMENT_SHELLS}, ${GENERIC_MASKS}, ${EXPLICIT}`);
  for (const el of candidates) {
    if (el.closest(CHAT_ROOTS)) continue;
    if (!isShown(el)) continue;
    if (el.hasAttribute("data-hide-chat")) return true;
    if (coversViewport(el)) return true;
  }
  return false;
}

function check() {
  scheduled = false;
  const next = detect();
  if (next === open) return;
  open = next;
  listeners.forEach((fn) => fn(open));
}

// DOM 变化可能一帧里来很多次（动画、图表），合并到下一帧只算一次
function schedule() {
  if (scheduled) return;
  scheduled = true;
  window.requestAnimationFrame(check);
}

function start() {
  if (started || typeof window === "undefined" || typeof MutationObserver === "undefined") return;
  started = true;
  // v-if 开关的遮罩走 childList，v-show / 过渡动画改的是 style、class
  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "style"],
  });
  // 淡入淡出结束时不一定有属性变化，补一个兜底
  document.addEventListener("transitionend", schedule, true);
  window.addEventListener("resize", schedule);
  check();
}

/**
 * 订阅遮罩开关状态。订阅时立即回调一次当前状态。
 * @param {(open: boolean) => void} fn
 * @returns {() => void} 取消订阅
 */
export function onOverlayChange(fn) {
  listeners.add(fn);
  start();
  fn(open);
  return () => listeners.delete(fn);
}
